import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {NeighborsConfig} from '../search/search.component';
import Env from '../../../env/env';

export interface NeighborsData {
  id: string;
  case: string;
  error?: string;
  row: string[];
  columns: string[];
}

@Component({
  selector: 'app-neighbors',
  templateUrl: './neighbors.component.html',
  styleUrls: ['./neighbors.component.css']
})
export class NeighborsComponent implements OnInit {
  ids: string[] = [];
  case: string;
  neighborThreshold: string;
  results: NeighborsData[];

  constructor(private http: HttpClient, private route: ActivatedRoute) { }

  ngOnInit() {
    this.ids = this.route.snapshot.queryParamMap.getAll('id');
    this.case = this.route.snapshot.queryParamMap.get('case');
    this.neighborThreshold = this.route.snapshot.queryParamMap.get('nt');

    let params = new HttpParams();
    params = params.append('case', this.case);
    params = params.append('nt', this.neighborThreshold);
    this.ids.forEach((id) => {
      params = params.append('id', id);
    });

    if (this.case.toLowerCase() === 'custom') {
      Object.keys(new NeighborsConfig()).forEach((k) => {
        params = params.append(k, this.route.snapshot.queryParamMap.get(k));
      });
    }

    this.http.get<NeighborsData[]>(Env.apiUrl + '/vma/processNeighbors', { params }).subscribe((data) => {
      this.results = data;
    });
  }

  getColumn(name: string, result: NeighborsData) {
    return result.row[result.columns.indexOf(name)];
  }

  getDescription(result: NeighborsData) {
    return (`${this.getColumn('artwork_name', result)}, ${this.getColumn('artwork_date', result)}` +
      ` (${this.getColumn('artist_name_analysis', result)})`).trim();
  }
}
